var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "chip", staticClass: "ax-icon-chip ax-icon-chip--expand-on-click" },
    [
      _c(
        "div",
        {
          staticClass: "ax-icon-chip__icon",
          style:
            "background-color: " +
            _vm.entityIconColor +
            "; color: " +
            _vm.entityIconFontColor
        },
        [_vm._v("\n        " + _vm._s(_vm.contextCode) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "ax-icon-chip__label" }, [
        _vm._v("\n        " + _vm._s(_vm.entityName) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ax-icon-chip__sublabel" }, [
        _vm._v("\n        " + _vm._s(_vm.entityCode) + "\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }